import React from "react";
import { Link } from "react-router";
import getPath from "../../../shared/utils/getPath";

export default function Partners() {
  const districts = [
    {
      name: "Logo Bezirk Unterfranken",
      image: "Bezirk-Unterfranken-Logo-weiß.png",
      href: "https://www.bezirk-unterfranken.de/"
    },
    {
      name: "Logo Bezirk Niederbayern",
      image: "Bezirk-Niederbayern-Logo-weiß.png",
      href: "https://www.bezirk-niederbayern.de/"
    },
    {
      name: "Logo Bezirk Oberpfalz",
      image: "Bezirk-Oberpfalz-Logo-weiß.png",
      href: "https://www.bezirk-oberpfalz.de/"
    }
  ];
  const partners = [
    {
      name: "Logo MPZ",
      image: "MPZ_Logo-weiss.png",
      href: "https://www.mpz-bayern.de/"
    },
    {
      name: "Logo MIK",
      image: "logo-mik-weiss.png",
      href: "https://museum-ins-klassenzimmer.de/"
    },

  ];

  return (
    <footer className="partner-footer container-fluid">
      <div className="partner-footer-inner">
        <div className="dark">
          <div className="row">
            <div className="col-sm-12 text-center">
              MUSbi ist ein Projekt der KulturServiceStelle des Bezirks
              Oberfranken.
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 hidden-sm" />

            <div className="col-md-3 col-xs-6">
              <h4>Projektträger</h4>
              <a href="https://www.bezirk-oberfranken.de/">
                <img
                  className="partner-image"
                  alt="Logo Bezirk Oberfranken"
                  src="/static/images/Logo_Bezirk_Oberfranken_weiß.png"
                />
              </a>
            </div>
            <div className="col-md-5 col-xs-6">
              <div className="row partners">
                <h4 className="col-xs-12">Unsere Partner</h4>
                <div className="row">
                  {partners.map(partner => (
                    <div
                      key={partner.name}
                      className="partner col-xs-12 col-sm-6 col-md-3"
                    >
                      <a href={partner.href}>
                        <img
                          className="partner-image"
                          style={{ maxWidth: "100%" }}
                          alt={partner.name}
                          src={`/static/images/${partner.image}`}
                        />
                      </a>
                    </div>
                  ))}
                </div>
                <div className="row">
                  {districts.map(partner => (
                    <div
                      key={partner.name}
                      className="partner col-xs-12 col-sm-6 col-md-3"
                    >
                      <a href={partner.href}>
                        <img
                          className="partner-image"
                          style={{ maxWidth: "100%" }}
                          alt={partner.name}
                          src={`/static/images/${partner.image}`}
                        />
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-md-3 hidden-sm" />
          </div>
        </div>

        <div className="container-fluid button-area">
          <Link to={getPath("frontend", "project")} className="btn btn-primary">
            <i className="glyphicon glyphicon-info-sign" /> Informationen zum
            Projekt
          </Link>
          <Link to={getPath("frontend", "contact")} className="btn btn-primary">
            <i className="glyphicon glyphicon-envelope" /> Kontaktanfrage
          </Link>
        </div>
      </div>
    </footer>
  );
}



// WEBPACK FOOTER //
// ./src/frontend/base/components/Partners.js